"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.some");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("@pcty/grid/lib/css/index.css");

require("@pcty/grid/lib/css/grid-list.css");

var _reactGrid = require("@pcty/react-grid");

var _typeValidation = _interopRequireDefault(require("./typeValidation"));

var _PctyGrid = require("./PctyGrid.common");

var _uuid = _interopRequireDefault(require("uuid"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PctyGrid = function PctyGrid(_ref) {
  var children = _ref.children,
      styleType = _ref.styleType,
      borderMode = _ref.borderMode,
      alternateRowStyle = _ref.alternateRowStyle,
      horizontalScrolling = _ref.horizontalScrolling,
      classNameWrapper = _ref.classNameWrapper,
      hover = _ref.hover,
      renderZeroState = _ref.renderZeroState,
      automationId = _ref.automationId,
      __TYPE = _ref.__TYPE,
      other = (0, _objectWithoutProperties2.default)(_ref, ["children", "styleType", "borderMode", "alternateRowStyle", "horizontalScrolling", "classNameWrapper", "hover", "renderZeroState", "automationId", "__TYPE"]);

  var otherProps = _objectSpread(_objectSpread({}, other), {}, {
    className: [hover ? '' : 'pcty-grid-nohover', alternateRowStyle ? 'pcty-grid-striped' : '', other.className || ''].join(' ').trim(),
    'data-automation-id': automationId || null
  });

  var wrapperCSS = ['pcty-grid-wrapper', horizontalScrolling ? 'pcty-grid-overflow' : '', classNameWrapper || ''].join(' ').trim();

  switch (styleType) {
    case 'data':
      otherProps.className = "pcty-grid ".concat(otherProps.className);
      break;

    case 'list':
      otherProps.className = "pcty-grid-list ".concat(otherProps.className);
      break;
  }

  switch (borderMode) {
    case 'top-none':
    case 'bottom-none':
      otherProps.className = "".concat(otherProps.className, " pcty-border-").concat(borderMode);
      break;

    case 'open':
      otherProps.className = "".concat(otherProps.className, " pcty-border-top-none pcty-border-bottom-none");
      break;

    default:
      break;
  }

  var bodyChildren = (0, _PctyGrid.renderChildrenByTypes)(children, [_reactGrid.PctyGridRow, _reactGrid.PctyExpandableGridRow, _reactGrid.PctyDividerGridRow]);
  var zeroState = null;

  if (bodyChildren.length <= 0 && !!renderZeroState) {
    zeroState = renderZeroState();

    if ((0, _typeof2.default)(zeroState) !== 'object' || !zeroState.props || zeroState.props.__TYPE !== 'PctyZeroState' && zeroState.props.__TYPE !== 'ZeroState') {
      zeroState = null;
    }
  }

  var hasExpandableChildren = bodyChildren.some(function (child) {
    return child.props.__TYPE === 'PctyExpandableGridRow' && child.props.expandableTable === true;
  });

  var returnExpandableChildren = function returnExpandableChildren() {
    return bodyChildren.map(function (x, index) {
      if (x.props.__TYPE === 'PctyExpandableGridRow' && x.props.expandableTable === true) {
        return x;
      }

      return /*#__PURE__*/_react.default.createElement("tbody", {
        key: "grid-tbody-".concat(index)
      }, x);
    });
  };

  var _ref2 = /*#__PURE__*/_react.default.createElement("tbody", null, bodyChildren);

  var handleTbody = function handleTbody() {
    if (hasExpandableChildren) {
      return returnExpandableChildren();
    }

    return _ref2;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperCSS
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-grid-container"
  }, /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({
    className: "pcty-grid-container-table",
    key: _uuid.default.v4()
  }, otherProps), /*#__PURE__*/_react.default.createElement("thead", {
    className: "pcty-grid-container-thead"
  }, (0, _PctyGrid.renderChildrenByTypes)(children, [_reactGrid.PctyGridHeaderRow])), handleTbody()), zeroState));
};

PctyGrid.propTypes = {
  /** Contains all row components */
  children: _propTypes.default.node.isRequired,

  /** When true, the row will receive hover styles and the hand pointer as the cursor. */
  hover: _propTypes.default.bool,

  /** Changes the style of the grid */
  styleType: _propTypes.default.oneOf(['data', 'list']),

  /** Changes the visible borders on the grid */
  borderMode: _propTypes.default.oneOf(['', 'top-none', 'bottom-none', 'open']),

  /** Alternates the background colors of each row. */
  alternateRowStyle: _propTypes.default.bool,

  /** Adds horizontal scrolling above mobile viewport. */
  horizontalScrolling: _propTypes.default.bool,

  /** A string of CSS classes for the wrapper div. */
  classNameWrapper: _propTypes.default.string,

  /** Render Function to display zero state when the grid is empty. The function must return a PctyZeroState component. */
  renderZeroState: _propTypes.default.func,

  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes.default.string,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyGrid');
  }
  /** INCLUDE OTHER */

};
PctyGrid.defaultProps = {
  styleType: 'list',
  borderMode: '',
  hover: false,
  alternateRowStyle: false,
  __TYPE: 'PctyGrid'
};
var _default = PctyGrid;
exports.default = _default;